import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import clientService from "../services/clientService";
import { update } from "lodash";
const initialState = {
    clients: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 5, // Size of each page
    isAdded: false, // Flag to indicate if a new client has been added

};

const clientSlice = createModule({
    name: 'clients',
    initialState,
    reducers: {
        search: (state) => {
            state.loading = true;
        },
        findAll: (state) => {
            state.loading = true;
        },
        addClient: (state) => {
            state.loading = true;
        },
        updateClient: (state) => {
            state.loading = true;
        },
        inactivate: (state) => {
            state.loading = true;
        },
        activate: (state) => {
            state.loading = true;
        },
        generatePdfReleve: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.clients = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },

        resetIsAdded: (state) => {
            state.isAdded = false;
        },

        getClientByIdRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getClientByIdSuccess: (state, { payload }) => {
            state.loading = false;
            state.currentClient = payload;
        },
        getClientByIdFailure: (state, { payload }) => {
            state.loading = false;
            state.error = payload || "Failed to fetch client";
            state.currentClient = null;
        },
        clearCurrentClient: (state) => {
            state.currentClient = null;
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                const { data } = yield call(clientService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data.body);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.findAll]({ payload }) {
            try {
                const { data } = yield call(clientService.findAll, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data.body);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addClient]({ payload }) {
            try {
                const { data } = yield call(clientService.addClient, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess(data.body));
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
            }
        },
        *[A.updateClient]({ payload }) {
            try {
                yield call(clientService.update, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.inactivate]({ payload }) {
            try {
                yield call(clientService.inactivate, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.activate]({ payload }) {
            try {
                yield call(clientService.activate, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.generatePdfReleve]({ payload }) {
            try {
                const pdfData = yield call(clientService.generatePDFReleve, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.getClientByIdRequest]({ payload }) {
            try {
                const { id, onSuccess, onError } = payload;
                const { data } = yield call(clientService.getClientById, id);
                yield put(A.getClientByIdSuccess(data.body));

                if (onSuccess) {
                    yield call(onSuccess, data.body);
                }
            } catch (error) {
                console.error("Error fetching client by ID:", error);
                yield put(A.getClientByIdFailure(error.message));

                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
    }),
});

export default clientSlice;
export const clientActions = clientSlice.actions;